import React from 'react';
import Button from '../../../components/button/button';
import Modal from '../../../components/modal';

const RequestCallbackModal = (props) => {
  const {
    closeModal,
    requestCallback,
    modalIsOpen,
    callbackRequestComplete,
    requestCallBackModal: {
      title: requestCallbackTitle,
      text: requestCallbackText,
      cancel: requestCallbackCancel,
      apply: requestCallbackApply,
    },
    thankYouModal: {
      title: thankYouTitle,
      text: thankYouText,
    },
  } = props;

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className="vantage-modal"
      ariaHideApp={false}
    >
      <div className="events text-center">
        {callbackRequestComplete ?
          <React.Fragment>
            <h3>{thankYouTitle}</h3>
            <p>{thankYouText}</p>
          </React.Fragment>
          :
          <React.Fragment>
            <h3>{requestCallbackTitle}</h3>
            <p>{requestCallbackText}</p>
            <div className="text-right">
              <Button
                className="button clear mr-4"
                buttonText={requestCallbackCancel}
                onClick={closeModal}
              />
              <Button
                className="button do-business"
                buttonText={requestCallbackApply}
                onClick={requestCallback}
              />
            </div>
          </React.Fragment>
        }
      </div>
    </Modal>
  );
};

export default RequestCallbackModal;
